<i [class]="iconClass" class="custom-tag" [style.background]="backgroundColor"
 [pTooltip]="toolTip" tooltipPosition="top"></i>
